import * as React from 'react'
import loadable from '@loadable/component'

import { spacing } from '@thg-commerce/enterprise-theme'
import { Container, TextContainer } from './styles'

const PropositionIcon = loadable(
  () =>
    import('@thg-commerce/gravity-icons/src/components/PropositionCheckIcon'),
  { ssr: true, fallback: <div style={{ width: 24, height: 24 }} /> },
)

export interface PropositionBannerText {
  textOne: string
  textTwo: string
  textThree: string
  textFour?: string
  textFive?: string
  textSix?: string
}
export interface PropositionBarProps {
  text: PropositionBannerText[]
}

export const PropositionBanner = (props: PropositionBarProps) => {
  return (
    <Container>
      {props.text.map((text) => {
        return (
          text && (
            <TextContainer>
              <PropositionIcon style={{ marginRight: spacing(1) }} />
              {text}
            </TextContainer>
          )
        )
      })}
    </Container>
  )
}
